import { themed } from '@indeed/ifl-css';
import { StyledButtonLink } from '../ButtonLink/ButtonLink.js';
import { StyledTextLink } from '../TextLink/TextLink.js';
import { body, html } from '../GlobalStyles/GlobalStyles.js';
import { Text } from '../Text/Text.js';
import { Heading } from '../Heading/Heading.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import 'react';
import '../Button/Button.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '@emotion/react';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';
import '../LinkProvider/LinkProvider.js';
import '../IndeedThemeProvider/utils.js';

const styles = () => ({
  // Styles are broken into individual selectors due to conflicts with IFL components nested inside `ScopedStyles`
  "&": {
    ...html,
    ...body,
    // apply root styles to current scope
    variant: "styles.root"
  },
  [`h1:not(${Text}):not(${Heading})`]: {
    variant: "styles.h1"
  },
  [`h2:not(${Text}):not(${Heading})`]: {
    variant: "styles.h2"
  },
  [`h3:not(${Text}):not(${Heading})`]: {
    variant: "styles.h3"
  },
  [`h4:not(${Text}):not(${Heading})`]: {
    variant: "styles.h4"
  },
  [`h5:not(${Text}):not(${Heading})`]: {
    variant: "styles.h5"
  },
  [`h6:not(${Text}):not(${Heading})`]: {
    variant: "styles.h6"
  },
  hr: {
    variant: "styles.hr"
  },
  [`p:not(${Text})`]: {
    variant: "styles.p"
  },
  [`b`]: {
    variant: "styles.b"
  },
  [`strong`]: {
    variant: "styles.strong"
  },
  // apply styles from theme to current scope
  [`a:not(${StyledButtonLink}):not(${StyledTextLink})`]: {
    variant: "styles.a"
  }
});

/**
 * @see https://experience.indeed.design/components/ids/scoped-styles
 */
const ScopedStyles = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  target: "eazdjqo0"
} : {
  target: "eazdjqo0",
  label: "ScopedStyles"
})(styles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
ScopedStyles.displayName = "ScopedStyles";

export { ScopedStyles, styles };
